module.exports = __webpack_public_path__ + "static/media/referralAd-bg.950a739c.svg";